
import Layout from '@/layout/TheLayout.vue'
import { EXTRANET_GROUPS, SUPPLIER_GROUPS_LOW_TIER } from './utils'

export default [
  {
    path: '/',
    name: 'Zonas',
    component: Layout,
    meta: {
      excludeGroup: [...EXTRANET_GROUPS, ...SUPPLIER_GROUPS_LOW_TIER, 'DesProveedores', 'Proveedor']
    },
    children: [
      {
        path: '/zonas',
        name: 'Zones',
        component: () => import('@/pages/catalogs/zones/index.vue'),
        meta: {
          title: 'Zonas',
          showInSidebar: true,
          icon: 'mdi-map-marker-radius',
          ifCan: {
            view: 'zones/zone'
          }
        }
      }
    ]
  }
]
